<template>
  <div class="tabs-content">
    <ul>
      <li
        v-for="(item,index) in tagsList"
        :key="index"
        @click="itemChange(index)"
        :class="{ active: item.isActive }"
      >{{item.title}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "tabs",
//   props: {
//     arrList: Array
//   },
data() {
    return {
        tagsList: []
    }
},
  created() {
      this.tagsList = tags;
  },
  methods: {
    itemChange(index) {
      var _this = this;
      for (var i = 0; i < _this.arrList.length; i++) {
        if (i == index) {
          _this.arrList[i].isActive = true;
        } else {
          _this.arrList[i].isActive = false;
        }
      }
      sessionStorage.setItem("tagindex", index);
     try {
        _this.$router.push({ path: _this.arrList[index].path });
     } catch (error) {
       
     }
    }
  },
  mounted(){
    if (sessionStorage.getItem("tagindex") != null) {
      var index = sessionStorage.getItem("tagindex");
      this.itemChange(index);
    } else {
      this.itemChange(0);
    }
  }
};
</script>
<style scoped>
.tabs-content {
  width: 100%;
  height: 44px;
  position: relative;
  background-color: #161823;
  text-align: center;
}
.tabs-content ul {
  position: relative;
  padding: 0 0;
  margin: 0 0;
  display: inline-flex;
  justify-content: center;
  list-style: none;
}
.tabs-content ul li {
  position: relative;
  padding: 0 0;
  text-align: center;
  margin: 0 0;
  list-style: none;
  width: 60px;
  height: 44px;
  line-height: 44px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(188, 189, 193, 1);
}
.tabs-content .active {
  font-weight: bold;
  color: rgba(250, 206, 21, 1);
}
.tabs-content .active::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 30%;
  bottom: 2px;
  height: 3px;
  border-radius: 1.5px;
  background-color: #face15;
}
</style>


// WEBPACK FOOTER //
// src/components/tabs.vue